import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import { ButtonIcon, useToast } from '@morressier/alembic';
import { downloadFile } from 'src/utils/file';
import { isLocal } from '../../../../utils/env';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDownToBracket
} from '@fortawesome/pro-regular-svg-icons';
import FileViewerButtonText from 'src/components/Submission/FileViewerButtonText';

type IProps = {
  file: ISubmissionFile;
  filenameDisplay?: 'referenceName' | 'fileName';
  display?: string;
  submissionContextId: string;
};

export const FileDisplay: React.FC<IProps> = ({
  file,
  filenameDisplay,
  display,
  submissionContextId
}) => {
  const displayLabel =
    filenameDisplay && filenameDisplay === 'fileName'
      ? file.name
      : file.referenceName;

  const toast = useToast();

  return (
    <Flex flexDirection="column" textStyle="headingItem">
      <Flex
        key={file.id || file.url}
        flexDirection="row"
        justifyContent="space-between"
        backgroundColor="surfacePrimaryFill"
        paddingY={2}
      >
        <Flex alignItems="center" flexDirection="row">
          <FileViewerButtonText
            file={file}
            submissionContextId={submissionContextId}
            textStyle="textBody"
            wordBreak={'break-word'}
            whiteSpace="normal"
            textAlign={'start'}
          >
            {display ? displayLabel : file.name}
          </FileViewerButtonText>

          <ButtonIcon
            icon={<FontAwesomeIcon icon={faArrowDownToBracket} />}
            ariaLabel="Download file"
           onClick={() => {
              downloadFile(file.url).catch(_e => {
                toast({
                  variant: 'error',
                  title: 'Error',
                  description: `Failed to obtain access to the file.${
                    isLocal ? ' Are you port-forwarding to asset-api?' : ''
                  }`,
                  isClosable: true
                });
              });
            }}
          ></ButtonIcon>
        </Flex>

        <Flex flexDirection={'row'} gap={8}></Flex>
      </Flex>
    </Flex>
  );
};
